import { type CustomCellRendererProps } from '@mint-lib/ag-grid/react';
import { type FC } from 'react';

import ChipGroup from '../../../components/ChipGroup.jsx';
import type { ApprovalTableItemData } from '../../../types/approversTable.js';
import type { ApproverEntity } from '../../../types/shared.js';

type Props = CustomCellRendererProps<ApprovalTableItemData, ApproverEntity[]>;

const RequesterCell: FC<Props> = ({ value }) => {
  if (!value?.length) {
    return null;
  }

  return (
    <div className="py-1">
      <ChipGroup
        items={value}
        maxVisibleChipsCount={2}
        tooltipContentSeparator={', '}
      />
    </div>
  );
};

export default RequesterCell;
